import { registerTool } from '../ToolRegistry'
import { getSharedToolRegistration } from '../sharedToolCatalog'
import { useClassStore } from '@/stores'

const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()

export function registerClassTools() {
  registerTool({
    ...getSharedToolRegistration('search_classes'),
    handler: async (args) => {
      try {
        const query = normalize(args?.query || '')
        if (!query) return { ok: false, error: 'Please provide a query.' }
        const limit = Math.max(1, Math.min(Number(args?.limit) || 10, 50))
        const classStore = await useClassStore()
        await classStore.fetchClasses?.()
        const classes = Array.isArray(classStore.classes) ? classStore.classes : []
        const matches = classes
          .filter((c) => {
            const name = normalize(c?.name || c?.title || c?.index || '')
            const index = normalize(c?.index || '')
            return name.includes(query) || index.includes(query)
          })
          .slice(0, limit)
        return { ok: true, count: matches.length, classes: matches }
      } catch (e) {
        return { ok: false, error: e?.message || 'Failed to search classes' }
      }
    }
  })

  registerTool({
    ...getSharedToolRegistration('list_classes'),
    handler: async (args) => {
      try {
        const classStore = await useClassStore()
        await classStore.fetchClasses?.()
        const classes = Array.isArray(classStore.classes) ? classStore.classes : []
        const limit = Math.max(1, Math.min(Number(args?.limit) || 20, 50))
        const sliced = classes.slice(0, limit)
        const formatted = sliced
          .map((c, idx) => `${idx + 1}. ${c.name} (Hit Die: ${c.hit_die || '?'})`)
          .join(' ')
        return { ok: true, count: sliced.length, classes: sliced, formatted }
      } catch (e) {
        return { ok: false, error: e?.message || 'Failed to list classes' }
      }
    }
  })
}
